import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { obterUFs, obterMunicipiosPorUF } from '../../api/recursosAPI';
import { obterPostosAtendimentoPeloMunicipio } from '../../api/postoAtendimentoAPI';
import { RootState } from '../../app/store';
import * as mensagens from '../../common/Mensagens';
import { ConsultaPostoAtendimentoModel } from '../../model/consultaPostoAtendimento';
import { MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA, MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB } from '../../common/Mensagens';
export interface PostoAtendimentoState {
  ufs: any[];
  municipios: any[];
  postosAtendimento: any[];
  mensagem: string;
  tipoMensagem: string;
  ativarMensagem: boolean;
  temComunicacaoComAPI: boolean;
  versaoMinimaAceitavel: boolean;
}

const initialState: PostoAtendimentoState = {
  ufs: [],
  municipios: [],
  postosAtendimento: [],
  mensagem: '',
  tipoMensagem: '',
  ativarMensagem: false,
  temComunicacaoComAPI: false,
  versaoMinimaAceitavel: true
};

export const getUfs = createAsyncThunk('postoAtendimento/getUfs', async () => {
    return obterUFs();
});

export const getMunicipios = createAsyncThunk(
  'postoAtendimento/getMunicipios',
  async (codigoUfIbge: number) => {
    return obterMunicipiosPorUF(codigoUfIbge);
  }
);

export const getPostosAtendimentoPeloMunicipio = createAsyncThunk(
  'postoAtendimento/getPostosAtendimentoPeloMunicipio',
  async (consultaPostoAtendimentoModel: ConsultaPostoAtendimentoModel) => {
    return obterPostosAtendimentoPeloMunicipio(
      consultaPostoAtendimentoModel.numeroIbgeMunicipio,
      consultaPostoAtendimentoModel.tipoPosto,
      consultaPostoAtendimentoModel.latitude,
      consultaPostoAtendimentoModel.longitude,
      consultaPostoAtendimentoModel.tipoOrdenacao
    );
  }
);

export const postoAtendimentoSlice = createSlice({
  name: 'postoAtendimentoSlice',
  initialState,
  reducers: {
    limpar: (state) => {
      state.municipios = initialState.municipios;
      state.postosAtendimento = initialState.postosAtendimento;
    },
    ativarMensagem: (state, action) => {
      state.ativarMensagem = action.payload;
    },
    alterarMensagem: (state, action) => {
      state.mensagem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUfs.fulfilled, (state, action) => {
        state.ativarMensagem = false;
        state.ufs = action.payload;
        state.temComunicacaoComAPI = true;
      })
      .addCase(getUfs.rejected, (state, action) => {
        if (
          action.error?.message &&
          (action.error?.message.includes(MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA) ||
            action.error?.message.includes(MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB))
        ) {
          state.versaoMinimaAceitavel = false;
        } else {
          state.temComunicacaoComAPI = false;
        }
      })
      .addCase(getMunicipios.fulfilled, (state, action) => {
        state.ativarMensagem = false;
        state.municipios = action.payload;
        state.temComunicacaoComAPI = true;
      })
      .addCase(getMunicipios.rejected, (state, action) => {
        state.temComunicacaoComAPI = false;
      })
      .addCase(getPostosAtendimentoPeloMunicipio.fulfilled, (state, action) => {
        state.postosAtendimento = action.payload;
        state.ativarMensagem = false;
        if (!state.postosAtendimento || state.postosAtendimento.length === 0) {
          state.tipoMensagem = 'warning';
          state.mensagem = mensagens.MSG_POSTO_ATENDIMENTO_NAO_ENCONTRADO;
          state.ativarMensagem = true;
        }
      });
  },
});

export const { limpar, ativarMensagem, alterarMensagem } = postoAtendimentoSlice.actions;

export const selectComunicacaoAPI = (state: RootState) => state.postoAtendimento.temComunicacaoComAPI;
export const selectVersaoMinimaAceitavel = (state: RootState) => state.postoAtendimento.versaoMinimaAceitavel;
export const selectUfs = (state: RootState) => state.postoAtendimento.ufs;
export const selectMunicipios = (state: RootState) => state.postoAtendimento.municipios;
export const selectPostosAtendimento = (state: RootState) =>
  state.postoAtendimento.postosAtendimento;

export const selectState = (state: RootState) => state.postoAtendimento;

export default postoAtendimentoSlice.reducer;
